import { InputTypes } from 'constants/enums';
import { IFormField } from 'models/app';
import React from 'react';
import Modal from 'components/UI/DialogModal';
import Form from 'components/UI/Form';
import { CircularProgress, Grid } from '@mui/material';
import MuiButton from 'components/UI/MuiButton';
import { ICompany } from 'models/company';
import { IIndustry } from 'models/industry';
import { useTranslation } from 'react-i18next';


interface Props {
  open: boolean;
  loading: boolean;
  company: ICompany;
  industries: IIndustry[];
  onClose: () => void;
  onSubmit: () => void;
  onChanges: (name: string, value: any) => void;
}




const EditCompany: React.FC<Props> = ({ open, loading, company, industries, onClose, onSubmit, onChanges }) => {
  const { t } = useTranslation()

  let industriesOptions = industries.map((industry) => {
    return {
      value: industry.id.toLowerCase(),
      label: industry.name
    };
  });
  let basicFields: IFormField[] = [
    {
      name: 'Name',
      label: t('T_name'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name'),
      internalLabel: true,
      required: true,
      defaultValue: company.name,
    },
    {
      name: 'NameAr',
      label: t('T_name') + ' ' + t('T_in_arabic'),
      type: InputTypes.TEXT,
      placeholder: t('T_enter_name') + t('T_in_arabic'),
      internalLabel: true,
      defaultValue: company.nameAr,
    },
    {
      name: 'IndustryId',
      label: t('T_industry_name'),
      type: InputTypes.SELECT,
      placeholder: t('T_industry_name'),
      options: industriesOptions,
      multiple: false,
      defaultValue: industriesOptions.find((c) => c.value === company.industryId.toLowerCase()),
      internalLabel: true,
      required: true
    },
    {
      name: 'IsCorporate',
      label: t('T_is_corporate'),
      type: InputTypes.CHECKBOX,
      defaultValue: company.isCorporate,
      internalLabel: true,
    },
    {
      name: 'Logo',
      label: t('T_Logo'),
      type: InputTypes.FILE,
      internalLabel: true,
      defaultImageUrl: company.logo,
    },
    {
      name: 'CertificateName',
      label: t('T_certificate_name') || 'Certificate Name',
      type: InputTypes.TEXT,
      placeholder: t('T_enter_certificate_name') || 'Enter Certificate Name',
      internalLabel: true,
      defaultValue: company.certificateName,
    },

  ];



  return (<>

    <Modal
      open={open}
      onClose={onClose}
      title={t('T_edit_company')}
      maxWidth="lg"
      children={<Grid container p={2}>
        <Form fields={basicFields} onChange={onChanges} />
      </Grid>}
      actions={
        <Grid container alignItems={'center'} justifyContent={'space-between'} px={1} >
          <MuiButton variant="contained"
            sx={{ bgcolor: 'warning.main', color: 'white' }}
            size='large' onClick={onClose}>
            {t('T_cancel')}
          </MuiButton>
          <MuiButton variant="contained"
            sx={{ bgcolor: 'primary.main', color: 'white' }}
            disabled={loading}
            size='large' onClick={onSubmit}>
            {t('T_save')}
            <CircularProgress
              size={10}
              sx={{ mx: 2, display: loading ? "" : "none" }}
            />
          </MuiButton>

        </Grid>
      }
    />
  </>
  );
};

export default EditCompany;